import { IAssemblyApplicationTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export const assemblyTypeQueryKey = 'assembly-type';

export function useAssemblyType(
    assemblyTypeId?: number,
    queryOptions?: UseQueryOptions<IAssemblyApplicationTypeResponse | undefined>
) {
    return useQuery({
        queryKey: [assemblyTypeQueryKey, assemblyTypeId],

        queryFn:
            assemblyTypeId !== undefined
                ? () =>
                      sdClient.getAssemblyApplicationType({
                          applicationTypeId: assemblyTypeId,
                      })
                : skipToken,

        ...queryOptions,
    });
}

export function invalidateAssemblyType(assemblyTypeId: number) {
    queryClient.invalidateQueries({
        queryKey: [assemblyTypeQueryKey, assemblyTypeId],
    });
}
